import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { Menu, Settings } from 'lucide-react';
import { useAuth } from '../context/authContext';
import Button from './Button';

const backpackLogo = process.env.PUBLIC_URL + '/assets/logo.jpg';

const CommonHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { userData } = useAuth();
  const navigate = useNavigate();
  const { organizationId: currentOrgId } = useParams(); // Get current org ID from URL
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  // Get organization name from location state or user data
  const orgName = location.state?.orgName || userData?.organizationName;
  console.log("values:",userData?.organizationName );

  const handleSettingsClick = () => {
    if (!currentOrgId) return;
    navigate(`/organization/${currentOrgId}/edit`, {
      state: { editMode: true, orgId: currentOrgId, orgName },
    });
  };

 const handleLogout = () => {
  // Clear auth
  localStorage.removeItem('authData');
  localStorage.removeItem('userData');


  navigate('/login', { replace: true });

 
  window.history.pushState(null, '', '/login');

  window.addEventListener('popstate', () => {
    window.history.pushState(null, '', '/login');
  });
};

  const getNavLinkProps = (path) => ({
    to: path,
    state: { orgId: currentOrgId, orgName }
  });

  const handleMembersClick = () => {
    if (!currentOrgId) return;
    navigate(`/organization/${currentOrgId}/users`, {
      state: { orgId: currentOrgId, orgName }
    });
  };

  const handleDevicesClick = () => {
    if (!currentOrgId) return;
    navigate(`/organization/${currentOrgId}/devices`, {
      state: { orgId: currentOrgId, orgName }
    });
  };

  const handleHomeClick = () => {
    if (!currentOrgId) return;
    if (userData?.role === "SUPERADMIN") {
      navigate('/organizations');
    } else {
      navigate(`/organization/${currentOrgId}`, {
        state: { orgId: currentOrgId, orgName }
      });
    }
  };

  return (
    <header style={headerStyle}>
      <div style={leftSectionStyle}>
        <Menu size={35} color="#fff" style={iconStyle} onClick={toggleMenu} />
        <img src={backpackLogo} alt="BackpackEMR Logo" style={logoStyle} />
        <Link
          {...getNavLinkProps(
            userData?.role === "SUPERADMIN" 
              ? "/organizations"
              : `/organization/${currentOrgId}`
          )}
          style={titleLinkStyle}
        >
          <span style={titleStyle}>Web Admin</span>
        </Link>
      </div>
      <div style={navAndSettingsWrapperStyle}>
        {!isMobile && (
          <nav style={navStyle}>
            <Button 
              onClick={handleHomeClick}
              style={linkStyle}
              text="Home"
            />
            <Button 
              onClick={handleMembersClick}
              style={linkStyle}
              text="Members"
            />
            <Button 
              onClick={handleDevicesClick}
              style={linkStyle}
              text="Devices"
            />
          </nav>
        )}
        <div style={rightSectionStyle}>
          <Settings 
            onClick={handleSettingsClick} 
            size={25} 
            color="#fff" 
            style={iconStyle} 
          />
        </div>
      </div>
      {menuOpen && (
        <div style={hamburgerMenuStyle}>
          {isMobile && (
            <>
              <Button 
                onClick={handleHomeClick}
                style={hamburgerItemStyle}
                text="Home"
              />
              <Button 
                onClick={handleMembersClick}
                style={hamburgerItemStyle}
                text="Members"
              />
              <Button 
                onClick={handleDevicesClick}
                style={hamburgerItemStyle}
                text="Devices"
              />
            </>
          )}
          <a href="https://myBackpackEMR.com" style={hamburgerItemStyle}>Web Portal</a>
          <a href="https://salesreach-free.salesreach.io/backpackemr-training-manuals-and-tutorials" style={hamburgerItemStyle}>Support and Tutorials</a>
          <span onClick={handleLogout} style={hamburgerItemStyle}>Logout</span>
        </div>
      )}
    </header>
  );
};

const headerStyle = { backgroundColor: '#006d7d', color: '#fff', padding: '10px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const leftSectionStyle = { display: 'flex', alignItems: 'center' };
const logoStyle = { width: '50px', height: '50px', marginLeft: '15px', marginRight: '10px' };
const titleStyle = { fontSize: '24px', fontWeight: 'bold' };
const navAndSettingsWrapperStyle = { display: 'flex', alignItems: 'center', gap: '30px' };
const navStyle = { display: 'flex', gap: '10px' };
const linkStyle = { color: '#fff', textDecoration: 'none', fontSize: '16px' };
const rightSectionStyle = { display: 'flex', alignItems: 'center' };
const iconStyle = { cursor: 'pointer' };
const titleLinkStyle = { textDecoration: 'none', color: '#fff' };
const hamburgerMenuStyle = { position: 'absolute', top: '60px', left: '10px', backgroundColor: '#006d7d', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '5px', zIndex: 1000, width: '200px', flexDirection: 'column' };
const hamburgerItemStyle = { padding: '10px 20px', color: '#fff', textDecoration: 'none', display: 'block', fontSize: '16px', borderBottom: '1px solid rgba(255, 255, 255, 0.2)', cursor: 'pointer' };

export default CommonHeader;
